import React, { useEffect } from 'react';
import { Skeleton } from 'antd';
import NetworkWidget from 'components/widgets/components/NetworkWidget';
import { useWidget } from 'components/Widget/useWidget';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import ninjaApi from 'store/redux/apis';

const NetworkQuickReportsData = ({ data, widget_key, height }) => {
  const [getNetworksReports, { data: reports = [], isLoading, isFetching }] =
    ninjaApi.useLazyNetworksReportsQuery();
  const { filters, chartConfig } = useWidget();

  const { date_from, date_to, date_range_key } = useWidgetDate(widget_key);

  useEffect(() => {
    const params = {
      load_chart: chartConfig?.load_chart,
      date_from: date_from,
      date_to: date_to,
      date_range_key: date_range_key,
      ...filters,
    };

    if (chartConfig?.load_chart) {
      params.group_by = 'date';
    }
    getNetworksReports(params).unwrap();
  }, [chartConfig?.load_chart, data, filters]);

  return (
    <Skeleton loading={isLoading || isFetching} active={true}>
      <NetworkWidget
        height={height - 65}
        data={reports[data?.defaultFilter?.network]}
        network={data?.defaultFilter?.network}
      />
    </Skeleton>
  );
};

export default NetworkQuickReportsData;
